import React from 'react'
import { useSelector } from 'react-redux';
import { helper } from '../utilities/helper';
import { TooltipIcon } from './Components';

const Input = ({pattern, inputMode, onFocus, onBlur, noAutoComplete,dangerous, noLabel, noLast, list, label, name, className, _ref, errors, id, row, rowLabel,flag, type = 'text', value, placeholder, autoFocus, fullName, tooltip, children, min, max, options, step, onChange, review }) => {



  if (fullName) return <div className={`field field-name ${row ? 'field-row' : ''} ${rowLabel ? 'field-rowLabel' : ''} ${className} `}>
  {!noLabel &&  <label htmlFor="first_name">Name:</label>}
    <input type="text" name='first_name' id='first_name' placeholder={noLabel ? 'First Name':'First'} ref={fullName({ required: 'Please enter user first name' })}  autoFocus={autoFocus}  />
    <input type="text" name='last_name' id='last_name' placeholder={noLabel ? 'Last Name':'Last'}  ref={noLast ? fullName : fullName({ required: 'Please enter user last name' })} />
    {(errors.first_name || errors.last_name) && <span className='loginError' >{errors.first_name?.message || errors.last_name?.message}</span>}
  </div>

  return <div className={`field ${row ? 'field-row' : ''} ${rowLabel ? 'field-rowLabel' : ''} ${review ? 'review' : ''}  ${className}  ${type === 'checkbox' ? 'field-check' : ''}`}>
    {!noLabel && <label htmlFor={id || name}>{review ? 'New ' : ''}{label || helper.tagUpper(name) + ':'} {tooltip && <TooltipIcon>{tooltip}</TooltipIcon>} {dangerous && <TooltipIcon icon='!' >This Field is dangerous to change manually, if you are not sure why ask Pedro</TooltipIcon>}</label>} {flag}
    {type === 'textarea' ?
      <textarea  autoFocus={autoFocus}  placeholder={placeholder} onBlur={onBlur} onFocus={onFocus} id={name} name={name} ref={_ref}>

        {children}
      </textarea>
      :
      type === 'select' ?
        <select value={value} id={name} name={name} ref={_ref} onChange={onChange}>

          {children}
          {options && options.map((op, i) => <option key={i} value={op}>{helper.tagUpper(op)}</option>)}
        </select>
        :
        <>
          <input onChange={onChange} pattern={pattern} checked={(onChange && typeof value === 'boolean') ? value:null} inputMode={inputMode} onBlur={onBlur} onFocus={onFocus} autoComplete={noAutoComplete ? "off" : 'on'} id={id || name} list={list ? name : undefined} type={name === 'email'? 'email' : type} name={name} ref={_ref} value={value} placeholder={placeholder || label || helper.tagUpper(name)} autoFocus={autoFocus} min={min} max={max} step={step} />
          {children}
        </>
    }
    {errors?.[name] && <span key={errors?.[name]} className='loginError colorText red' >{errors[name].message}</span>}
  </div>
}

export default React.memo(Input)